import { ElementRef, Injectable } from '@angular/core';
import { KeyDownEvent as ColorBoxKeyDownEvent } from 'devextreme/ui/color_box';
import {
  KeyDownEvent as SelectBoxKeyDownEvent,
  FocusOutEvent as SelectFocusOutEvent,
  ValueChangedEvent as SelectValueChangedEvent,
} from 'devextreme/ui/select_box';
import {
  KeyDownEvent as TagBoxKeyDownEvent,
  FocusOutEvent as TagBoxFocusOutEvent,
  ValueChangedEvent as TagBoxValueChangedEvent,
} from 'devextreme/ui/tag_box';
import { KeyDownEvent as TextAreaKeyDownEvent } from 'devextreme/ui/text_area';

@Injectable({
  providedIn: 'root',
})
export class FocusService {
  // Selectores HTML con los que se harán las busquedas
  private selectores = [
    'input:not([disabled]):not([type="hidden"]):not([disable="true"]):not([type="file"])',
    'textarea:not([disabled]):not([type="hidden"])',
  ].join(',');

  // Enfoca el primer campo visible
  focusPrimerCampo = (elementRef: ElementRef) => {
    let primerInput = this.findPrimerInput(elementRef);
    if (!primerInput) return;

    primerInput.focus();
  };

  // Enfoca el proximo campo visible
  focusProximoCampo = (campoActual: HTMLElement) => {
    // Delay en caso de que el proximo input este deshabilitado
    // y se active al ingresar el anterior
    setTimeout(() => {
      const proximoCampo = this.findProximoInput(campoActual);
      if (proximoCampo) {
        proximoCampo.focus();
      }
      // Si es el ultimo input, pierde el focus
      campoActual.blur();
    }, 0);
  };

  // Obtiene el primer elemento visible en el DOM de acuerdo a los selectores
  findPrimerInput = (elementRef: ElementRef): HTMLElement | null => {
    const contenedorFormulario =
      elementRef.nativeElement.querySelector('.form');
    if (!contenedorFormulario) return null;

    const primerInput = contenedorFormulario.querySelector(
      this.selectores,
    ) as HTMLElement;

    // return this.isElementoVisible(primerInput) ? primerInput : this.findProximoInput(primerInput);
    return primerInput;
  };

  // Obtiene el siguiente elemento visible en el DOM de acuerdo a los selectores
  findProximoInput = (campoActual: HTMLElement): HTMLElement | null => {
    /* Revisa todos los elementos que coincidan con los selectores y busca la posición del
    elemento pasado como parametro
    */
    const inputs = Array.from(
      document.querySelectorAll(this.selectores),
    ) as HTMLElement[];
    let indiceActual = inputs.indexOf(campoActual);

    // Comprueba que el elemento pasado como parametro existe y no sea el ultimo
    if (indiceActual == -1 || indiceActual >= inputs.length - 1) return null;

    let proximoCampo = inputs[indiceActual + 1] as HTMLElement;

    // Si el elemento obtenido es visible lo devuelve
    if (this.isElementoVisible(proximoCampo)) return proximoCampo;
    // En caso contrario busca el siguiente
    else return this.findProximoInput(proximoCampo);
  };

  isElementoVisible = (elemento: HTMLElement): boolean => {
    const style = window.getComputedStyle(elemento);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      elemento.offsetParent !== null &&
      elemento.getBoundingClientRect().height > 0
    );
  };

  // Enfoca proximo input
  onKeyDown(e: any) {
    if (e.key === 'Enter') {
      let currentElement = e.target as HTMLElement;
      this.focusProximoCampo(currentElement);
    }
  }

  // Abre y cierra los select al pulsar espacio
  onKeyDownSelect(e: SelectBoxKeyDownEvent) {
    if (e.event.key == ' ') {
      e.event.preventDefault();
      if (e.component.option('opened')) {
        e.component.close();
      } else e.component.open();
    } else if (e.event.key === 'Enter') {
      let currentElement = e.event.target as HTMLElement;
      this.focusProximoCampo(currentElement);
    }
  }

  // Abre y cierra los select al pulsar espacio
  onKeyDownTagbox(e: TagBoxKeyDownEvent) {
    if (e.event.key == ' ') {
      e.event.preventDefault();
      if (e.component.option('opened')) {
        e.component.close();
      } else e.component.open();
    } else if (e.event.key === 'Enter') {
      let currentElement = e.event.target as HTMLElement;
      this.focusProximoCampo(currentElement);
    }
  }

  // Abre y cierra los select al pulsar espacio
  onKeyDownColorBox(e: ColorBoxKeyDownEvent) {
    if (e.event.key == ' ') {
      e.event.preventDefault();
      if (e.component.option('opened')) e.component.close();
      else e.component.open();
    } else if (e.event.key === 'Enter') {
      e.component.close();
      let currentElement = e.event.target as HTMLElement;
      this.focusProximoCampo(currentElement);
    }
  }

  // Si se presiona junto a 'shift' no hace nada
  onKeyDownTextArea(e: any) {
    if (e.key === 'Enter' && !e.shiftKey) {
      let currentElement = e.target as HTMLElement;
      this.focusProximoCampo(currentElement);
      e.event.preventDefault();
    }
  }

  // Cierra el dropdown del select
  onValueChangedSelect(e: SelectValueChangedEvent) {
    setTimeout(() => {
      e.component.close();
    }, 0);
  }

  onFocusOutSelect = (e: SelectFocusOutEvent) => {
    e.component.close();
  };

  // Cierra el dropdown del tagbox
  onValueChangedTagbox(e: TagBoxValueChangedEvent) {
    setTimeout(() => {
      e.component.close();
    }, 0);
  }

  onFocusOutTagbox = (e: TagBoxFocusOutEvent) => {
    e.component.close();
  };
}
